import React from "react";
import { usePreguntasCalidad } from "../../hooks";
import { Preguntas } from "../Preguntas";
import usePreguntasPuntualidad from "../../hooks/usePreguntasPuntualidad";
import usePreguntasComunicacionReportes from "../../hooks/usePreguntasComunicacionReportes";
import usePreguntasResponsabilidadManejoVehiculo from "../../hooks/usePreguntasResponsabilidadManejoVehiculo";
import usePreguntasActitudTrabajoEquipo from "../../hooks/usePreguntasActitudTrabajoEquipo";

const PreguntasActitudTrabajoEquipo = () => {
	const { frmPreguntas, setPuntajeTotal } = usePreguntasActitudTrabajoEquipo();

	return (
		<Preguntas
			form={frmPreguntas}
			calcularPuntajeTotal={setPuntajeTotal}
			titulo="Actitud y trabajo en equipo (4/6)"
			opciones={[
				{ key: "seMuestraDispuestoColaborarConOtrasAreas", label: "Se muestra dispuesto a colaborar con otras áreas cuando se le requiere" },
				{ key: "mantieneBuenaRelacionConCompanieros", label: "Mantiene buena relación con compañeros, supervisores y ejecutiva comercial" },
				{ key: "demuestraCompromisoEmpresaYSusFunciones", label: "Demuestra compromiso con la empresa y sus funciones" },
				{ key: "resuelveConflictos", label: "Resuelve conflictos de forma madura y respetuosa" }
			]}
		/>
	);
};

export default PreguntasActitudTrabajoEquipo;
